import React from 'react';
import { Globe, LayoutGrid, Camera, Compass, Lock, Banknote } from 'lucide-react';
export function ServicesGrid() {
  const services = [{
    icon: <Globe className="w-6 h-6 text-brick-red" data-id="element-280" />,
    title: 'Extensive Online Presence',
    description: 'Your listing syndicated to 100+ sites including Zillow, Realtor.com, Redfin, and Trulia.'
  }, {
    icon: <LayoutGrid className="w-6 h-6 text-brick-red" data-id="element-281" />,
    title: 'MLS Listings',
    description: 'Full MLS access puts your home in front of every agent and qualified buyer in Arizona.'
  }, {
    icon: <Camera className="w-6 h-6 text-brick-red" data-id="element-282" />,
    title: 'Professional Photography',
    description: 'High resolution photography and virtual tours that make your home stand out in the scroll.'
  }, {
    icon: <Compass className="w-6 h-6 text-brick-red" data-id="element-283" />,
    title: 'Expert Guidance',
    description: 'Pricing strategy, staging advice, and negotiation leadership from licensed agents.'
  }, {
    icon: <Lock className="w-6 h-6 text-brick-red" data-id="element-284" />,
    title: 'High Security Showings',
    description: 'Secure lockbox, verified showings, and detailed buyer feedback after every visit.'
  }, {
    icon: <Banknote className="w-6 h-6 text-brick-red" data-id="element-285" />,
    title: 'Cash Buyer Option',
    description: 'Need to sell fast? We have vetted cash buyers ready to make competitive offers.'
  }];
  return <section className="py-20 md:py-32 bg-cream" data-id="element-286">
      <div className="container mx-auto px-4 md:px-6" data-id="element-287">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-288">
          <p className="text-gold text-xs font-bold tracking-[0.2em] uppercase mb-4" data-id="element-289">
            What's Included at 1%
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal leading-tight" data-id="element-290">
            A full service experience. Not a discount one.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-291">
          {services.map((service, index) => <div key={index} className="bg-white p-8 border border-gold/20 rounded-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg group" data-id="element-292">
              <div className="w-12 h-12 bg-cream rounded-full flex items-center justify-center mb-6 group-hover:bg-brick-red/10 transition-colors" data-id="element-293">
                {service.icon}
              </div>
              <h3 className="font-serif text-xl text-charcoal mb-3" data-id="element-294">
                {service.title}
              </h3>
              <p className="text-muted-foreground mb-6 leading-relaxed" data-id="element-295">
                {service.description}
              </p>
              <a href="#" className="text-brick-red font-medium text-sm flex items-center hover:underline" data-id="element-296">
                Learn more <span className="ml-1" data-id="element-297">→</span>
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}